import Cookies from 'js-cookie';
import { APP_CACHE_STORAGE_DRIVER } from '../config';

export default {
  getUserName(): string | null {
    const storage = window[APP_CACHE_STORAGE_DRIVER];
    return storage.getItem('username');
  },
  setUserName(username: string) {
    console.log(`storage.service setUserName: ${username}`);
    const storage = window[APP_CACHE_STORAGE_DRIVER];
    storage.setItem('username', username);
  },
  removeUserName() {
    const storage = window[APP_CACHE_STORAGE_DRIVER];
    storage.removeItem('username');
  },
  setJwtCookie(jwt: string) {
    // NOTE: js-cookie writes via document.cookie, so HttpOnly cannot be applied
    // here — only a server-side Set-Cookie header can. Making the JWT HttpOnly
    // would require issuing it server-side (tracked separately). Until then we
    // keep Secure + SameSite=Strict: the JWT is read back via getJwtCookie() and
    // attached as an `Authorization: Bearer` header, never auto-sent as a cookie,
    // so Strict is safe and gives the strongest CSRF protection.
    Cookies.set('jwt', jwt, {
      path: '/',
      sameSite: 'strict',
      secure: true,
      expires: 26000,
    });
  },
  getJwtCookie(): string | undefined {
    return Cookies.get('jwt');
  },
  removeJwtCookie() {
    Cookies.remove('jwt');
  },

  getItem(key: string) {
    const storage = window[APP_CACHE_STORAGE_DRIVER];
    return storage.getItem(key);
  },
  setItem(key: string, value: string) {
    const storage = window[APP_CACHE_STORAGE_DRIVER];
    return storage.setItem(key, value);
  },
  removeItem(key: string) {
    const storage = window[APP_CACHE_STORAGE_DRIVER];
    return storage.removeItem(key);
  },
};
